<template>
    <div class="container mescroll-touch">
        <img src="../../assets/images/baseinfotop.png" class="img" />
        <!-- <img src="../../assets/images/topguanggao.png" class="guanggaoimg" /> -->
        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/zbdanwei.png" class="modeltitleimg" />
                    <div class="modeltitletext">主办单位</div>
                </div>
            </div>
            <div class="neirong ziti">中国医药教育协会</div>
            <div class="ziti">中国医药卫生文化协会</div>
            <!-- <div class="ziti">中国抗衰老促进会</div> -->
        </div>

        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/zbdanwei.png" class="modeltitleimg" />
                    <div class="modeltitletext">承办单位</div>
                </div>
            </div>
            <div class="neirong ziti">中国医药教育协会专家工作委员会</div>
            <div class="ziti">中国医药教育协会皮肤与健康教育专业委员会</div>
            <div class="ziti">复旦大学附属华山医院</div>
        </div>

        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/zbdanwei.png" class="modeltitleimg" />
                    <div class="modeltitletext">报到时间</div>
                </div>
            </div>
            <div class="neirong ziti">2025年8月22日全天</div>
        </div>

        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/zbdanwei.png" class="modeltitleimg" />
                    <div class="modeltitletext">会议时间</div>
                </div>
            </div>
            <div class="neirong ziti">2025年8月23日至24日</div>
        </div>

        <div class="model">
            <div class="modelline">
                <div class="modeltitle">
                    <img src="../../assets/images/zbdanwei.png" class="modeltitleimg" />
                    <div class="modeltitletext">会议地点</div>
                </div>
            </div>
            <div class="neirong ziti">上海光大会展中心国际大酒店</div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'regmeeting',
    data() {
        return {
        }
    },
    components: {
    },
    created() {
        document.title = "ACMED第一届学术年会";
    },
    methods: {
    }
}
</script>

<style lang="scss" scoped>
.container {
    height: 100%;
    width: 100%;
    // background: rgb(228, 236, 255);
}

.img {
    display: block;
    width: 100%;
    margin-bottom: .2rem
}

.guanggaoimg {
    display: block;
    width: 92%;
    margin: 0.5rem auto;
}

.modelline {
    border-bottom: 1px solid rgb(179, 178, 255);
    border-bottom-left-radius: 50rem;
}

.modeltitle {
    background: #b3b2ff;
    width: 37%;
    display: flex;
    flex-direction: row;
    padding: 0.1rem;
    border-radius: 30px 50px 0px 30px;
}

.modeltitleimg {
    display: block;
    width: 15%;
}

.modeltitletext {
    margin-left: 0.2rem;
    color: #fff;
    font-weight: bold;
    // font-size: 16px;
}

.model {
    width: 92%;
    margin: auto;
    margin-top: 0.5rem;
}

.center {
    text-align: center;
}

.preple {
    color: rgb(177, 172, 255);
}

.neirong {
    margin-top: .3rem
}

.ziti {
    font-size: .37rem;
}
</style>